<!--
 * @Author: Cathy
 * @Date: 2020-02-25 10:49:34
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-20 17:07:49
 * @Description: 目录组件
 -->
<template>
  <div class="catalogue">
    <div v-if="!show"
         class="floatDiv"
         @click="onShowPopup">目录</div>
    <div v-else
         class="listTitle">
      <label>目录</label>
    </div>
    <van-popup v-model="show"
               position="bottom"
               :style="{ height: '40%', paddingTop: '0.7rem' }"
               :duration="0"
               round>
      <div class="catalogueList">
        <div class="listItem"
             v-for="(item, index) in list"
             :key="index"
             @click="onToAnchor(index)">
          <p>{{index + 1}}.{{item.title}}</p>
          <div v-if="active === index"
               class="bottomWire"></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'catalogue',
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  data () {
    return {
      show: false,
      active: 0
    }
  },
  methods: {
    onShowPopup () {
      this.show = !this.show
    },
    onToAnchor (index) {
      this.active = index
      document.querySelector('#title' + index).scrollIntoView({ behavior: 'smooth' })
      this.onShowPopup()
    },
    onScroll (event) {
      let ws = window.scrollY // 当前滚动条位置
      for (let index = 0; index < this.list.length; index++) {
        let ele = document.getElementById('title' + index)
        if (ws >= ele.offsetTop - 1) {
          this.active = index
        }
      }
    }
  }
}
</script>

<style scoped>
.catalogue >>> .van-popup--bottom.van-popup--round {
  border-radius: 0.16rem 0.16rem 0 0;
}
.floatDiv {
  position: fixed;
  bottom: 20%;
  right: 3%;
  width: 1.37rem;
  height: 0.73rem;
  background: rgba(250, 170, 34, 1);
  border-radius: 0.16rem;
  color: #fff;
  font-size: 0.36rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.listTitle {
  position: fixed;
  bottom: 37%;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 3000;
}
.listTitle label {
  width: 1.37rem;
  height: 0.73rem;
  background: rgba(250, 170, 34, 1);
  border-radius: 0.16rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.3rem;
}
.catalogueList {
  padding: 0 0.32rem;
}
.listItem {
  height: 0.88rem;
  padding-top: 0.25rem;
  text-align: center;
  color: #202020;
  font-size: 0.3rem;
  border-bottom: 1px solid #d3d3d3;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.listItem:nth-last-child(1) {
  border-bottom: none;
}
.bottomWire {
  margin: auto;
  width: 1.22rem;
  height: 0.06rem;
  background: rgba(250, 170, 34, 1);
  border-radius: 0.03rem;
}
</style>
